var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.95801C0 13.378 3.58 16.958 8 16.958C12.42 16.958 16 13.378 16 8.95801C16 4.53801 12.42 0.958008 8 0.958008C3.58 0.958008 0 4.53801 0 8.95801ZM11.29 6.24801C11.47 6.06801 11.72 5.95801 12 5.95801C12.55 5.95801 13 6.40801 13 6.95801C13 7.23801 12.89 7.48801 12.71 7.66801L7.71 12.668C7.53 12.848 7.28 12.958 7 12.958C6.72 12.958 6.47 12.848 6.29 12.668L3.29 9.66801C3.11 9.48801 3 9.23801 3 8.95801C3 8.40801 3.45 7.95801 4 7.95801C4.28 7.95801 4.53 8.06801 4.71 8.24801L7 10.548L11.29 6.24801Z",
    fill: "#52BD94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.46ea107f.svg";
export { ForwardRef as ReactComponent };